const gratificationPrintButton = document.querySelector(
  ".js-print-gratification",
);
if (gratificationPrintButton) {
  gratificationPrintButton.addEventListener("click", function () {
    window.print();
    return false;
  });
}
